import React, {useEffect} from 'react';
import {StyleSheet, Text, TouchableOpacity, TouchableWithoutFeedback, View} from "react-native";
import {useDispatch, useSelector} from 'react-redux';
import {Icon} from "react-native-elements";

import * as Animatable from 'react-native-animatable';
import {getConfig, getMessage, setMessage} from "../reducers/configSlice";
import {MESSAGE_TYPE_ERROR, MESSAGE_TYPE_SUCCESS} from "../constants/default";
import {FONT_FAMILY} from "../constants/styleConstants";

import {actuatedNormalize} from "../services/helpers/stylingHelpers";

const Notification = () => {
    const dispatch = useDispatch()
    const message = useSelector(getMessage)
    const config = useSelector(getConfig)

    useEffect( () => {
        if (message) {
            setTimeout( () => {
                dispatch(setMessage(null))
            }, config.errorTimeout * 1000)
        }
    }, [message])

    return (
        message &&
            <TouchableWithoutFeedback onPress={() => dispatch(setMessage(null))}>
                <Animatable.View useNativeDriver={true} animation="pulse" duration={2500} iterationCount="infinite" style={[styles.success, message.type === MESSAGE_TYPE_ERROR && styles.error]}>
                    <View style={[styles.details]}>
                        {message.type === MESSAGE_TYPE_SUCCESS && <Icon size={actuatedNormalize(35)} name="check-circle" type="material-community" color="#41BED3" />}
                        {message.type === MESSAGE_TYPE_ERROR && <Icon size={actuatedNormalize(35)} name="error" type="material" color="#ff0000" />}
                        <Text style={[styles.text, message.type === MESSAGE_TYPE_ERROR && styles.errorText]}>
                            {message.message}
                        </Text>
                    </View>
                    <TouchableOpacity onPress={() => dispatch(setMessage(null))}>
                        <Text style={[styles.dismiss, message.type === MESSAGE_TYPE_ERROR && styles.errorDismiss]}>
                            {translate("Dismiss").toUpperCase()}
                        </Text>
                    </TouchableOpacity>
                </Animatable.View>
            </TouchableWithoutFeedback>
    );
};

const styles = StyleSheet.create({
    success: {
        position: 'absolute',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        bottom: '4%',
        left: '3%',
        width: '94%',
        height: '12%',
        backgroundColor: 'white',
        shadowOffset:{  width: 0,  height: 15 },
        shadowColor: '#000000',
        shadowOpacity: 0.4,
        shadowRadius: 12,
        elevation: 15,
        paddingLeft: '3%',
        paddingRight: '3%',
    },
    error: {
        backgroundColor: '#000000',
    },
    details: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    text: {
        fontFamily: FONT_FAMILY,
        fontSize: actuatedNormalize(15),
        paddingLeft: '3%',
        width: '80%'
    },
    errorText: {
        color: '#FFFFFF',
        fontSize: actuatedNormalize(14),
    },
    dismiss: {
        color: '#41BED3',
        textDecorationLine: 'underline',
        textDecorationColor: '#41BED3',
        fontSize: actuatedNormalize(15),
        fontFamily: FONT_FAMILY,
    },
    errorDismiss: {
        color: '#ff0000',
        textDecorationColor: '#ff0000',
        fontSize: actuatedNormalize(14),
    }
});

export default Notification;
